import React from "react";
import { useTranslation } from "react-i18next";
import { EntryRow } from "./EntryRow";
import { EntryModel } from "../../models";

interface EntryListProps {
  entries: EntryModel[];
  onVoteUpdate?: (entryId: number, updates: Partial<EntryModel>) => void;
  onDelete?: (entryId: number) => void;
}

export const EntryList: React.FC<EntryListProps> = ({ entries, onVoteUpdate, onDelete }) => {
  const { t } = useTranslation();

  if (!entries || entries.length === 0) {
    return (
      <div className="no-entries">
        <p>{t("no_entries_message")}</p>
      </div>
    );
  }

  return (
    <div className="entry-list">
      {entries.map((entry) => (
        <EntryRow
          key={entry.id}
          entry={entry}
          onVoteUpdate={onVoteUpdate}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};